<div class="flex items-center w-fit h-screen m-auto">
  <div class="text-center grid gap-4 max-w-2xl">
    <h1 class="font-bold">
      {{ 'accountVerification:titleEmailVerified' | translate }}
    </h1>
    <p class="">
      {{ 'accountVerification:subtitleEmailVerified' | translate }} <br />
      {{ 'accountVerification:subtitleEmailVerified2' | translate }}
    </p>
    <small class="">
      {{ 'accountVerification:emailVerificationInstructions' | translate }}
    </small>
    <button
      class="rounded-lg xs:w-full"
      mat-stroked-button
      color="primary"
      (click)="resendVerificationEmail()">
      {{ 'accountVerification:statusEmailVerified' | translate }}
    </button>
  </div>

  <button
    class="rounded-lg xs:w-full w-40 top-0 right-0 m-2"
    mat-flat-button
    color="primary"
    (click)="logout()"
    style="position: absolute; margin: 2rem">
    Logout
  </button>
</div>
